import { ComponentIds, RoomPartType } from '@inter-ikea-core/core';
import { PlannerValidation } from './PlannerValidation';
import WallVisibilityComponent from '../components/WallVisibilityComponent';
import { CustomComponentIds } from '@inter-ikea-kvadrat/kvadrat';
// Validation rule to not snap frames or other entities with WallVisibilityComponent to hidden walls
export class WallVisibilityValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'WallVisibilityValidation');
        this.coreApi = coreApi;
        this.enabled = true;
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const guest = snapActionCandidate.guestRoot;
        const host = snapActionCandidate.host;
        if (!this.enabled ||
            (!guest.hasComponent(ComponentIds.FRAME_COMPONENT_ID) &&
                !guest.hasComponent(ComponentIds.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID) &&
                !guest.hasComponent(WallVisibilityComponent.id))) {
            return this.validationOK();
        }
        if (host.getComponent(ComponentIds.ROOM_PART_COMPONENT_ID)?.type ===
            RoomPartType.WALL) {
            // Only snap to walls that are rendered (not hidden)
            return host.hasComponent(ComponentIds.RENDERED_COMPONENT_ID)
                ? this.validationOK()
                : this.validationFail('Can´t snap to hidden walls');
        }
        else if (
        // If snapping to wall/floor edge, validate that the wall is rendered
        host.getComponent(ComponentIds.ROOM_PART_COMPONENT_ID)?.type ===
            RoomPartType.EDGE) {
            /*const wallForEdge = host.getComponent<EdgeRelationComponent>(
              CustomComponentIds.ROOM_EDGE_RELATION_COMPONENT_ID
            )?.surface1;*/
            const wallForEdge = host.getComponent(CustomComponentIds.ROOM_EDGE_RELATION_COMPONENT_ID)?.surface1;
            return wallForEdge?.hasComponent(ComponentIds.RENDERED_COMPONENT_ID)
                ? this.validationOK()
                : this.validationFail('Can´t snap to hidden walls');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=WallVisibilityValidation.js.map